type ApiOption = { displayName: string, id: string };
type ApiOrgOption = { organizationId: string, organizationName: string, organizationUrl: string };
export type UIOption = { text: string, key: string };

export const optionMapper = (options: ApiOption[] = []): UIOption[] => options.map((o) => ({ text: o.displayName, key: o.id }));
export const organizationToOptionMapper = (options: ApiOrgOption[]) => options.map((o) => ({ text: o.organizationName, key: o.organizationUrl }));
